import React, { useState } from 'react';
import { 
  Card, 
  CardBody, 
  Button,
  Divider,
  Chip
} from '@heroui/react';
import {
  Home,
  Users,
  Map,
  MessageSquare,
  Calendar,
  ShoppingCart,
  Shield,
  Search,
  Vote,
  Settings,
  MapPin
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const Navigation = ({ onCategoryChange, onShowMap, onShowMembers, currentCategory }) => {
  const { user } = useAuth();
  const [activeItem, setActiveItem] = useState(currentCategory || 'home');

  const handleItemClick = (itemId, category = null, action = null) => {
    setActiveItem(itemId);
    
    if (action === 'map') {
      onShowMap();
    } else if (action === 'members') {
      onShowMembers();
    } else if (category) {
      onCategoryChange(category);
    } else if (itemId === 'home') {
      onCategoryChange(null); // Show all posts
    }
  };

  const menuItems = [
    {
      id: 'home',
      label: 'Página Inicial',
      icon: Home,
      action: 'home'
    },
    {
      id: 'neighborhood',
      label: `Vizinhança ${user?.area?.name || ''}`,
      icon: MapPin,
      action: 'neighborhood'
    },
    {
      id: 'map',
      label: 'Mapa',
      icon: Map,
      action: 'map'
    }
  ];

  const categories = [
    {
      id: 'geral',
      label: 'Geral',
      icon: MessageSquare,
      category: 'Geral'
    },
    {
      id: 'eventos',
      label: 'Eventos',
      icon: Calendar,
      category: 'Eventos'
    },
    {
      id: 'venda',
      label: 'Compra e Venda',
      icon: ShoppingCart,
      category: 'Compra e Venda'
    },
    {
      id: 'seguranca',
      label: 'Segurança',
      icon: Shield,
      category: 'Segurança'
    },
    {
      id: 'achados',
      label: 'Achados e Perdidos',
      icon: Search,
      category: 'Achados e Perdidos'
    },
    {
      id: 'votacao',
      label: 'Votação',
      icon: Vote,
      category: 'Votação'
    }
  ];

  const directories = [
    {
      id: 'members',
      label: 'Membros',
      icon: Users,
      action: 'members'
    },
    {
      id: 'services',
      label: 'Serviços',
      icon: Settings,
      action: 'services'
    }
  ];

  const renderMenuItem = (item) => {
    const Icon = item.icon;
    const isActive = activeItem === item.id || 
                    (item.category && currentCategory === item.category);

    return (
      <Button
        key={item.id}
        variant={isActive ? "solid" : "light"}
        color={isActive ? "primary" : "default"}
        className="w-full justify-start h-auto p-3 mb-2 rounded-nextui-sm"
        startContent={<Icon className="w-4 h-4" />}
        onPress={() => handleItemClick(item.id, item.category, item.action)}
      >
        <span className="text-left flex-1">{item.label}</span>
      </Button>
    );
  };

  return (
    <div className="w-64 space-y-4">
      {/* Main Navigation */}
      <Card className="border border-gray-200 shadow-post bg-white rounded-nextui">
        <CardBody className="p-4">
          <div className="space-y-2">
            {menuItems.map(renderMenuItem)}
          </div>
        </CardBody>
      </Card>

      {/* Categories */}
      <Card className="border border-gray-200 shadow-post bg-white rounded-nextui">
        <CardBody className="p-4">
          <div className="mb-3">
            <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">
              Categorias
            </h3>
          </div>
          <div className="space-y-2">
            {categories.map(renderMenuItem)}
          </div>
        </CardBody>
      </Card>

      {/* Directories */}
      <Card className="border border-gray-200 shadow-post bg-white rounded-nextui">
        <CardBody className="p-4">
          <div className="mb-3">
            <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">
              Diretórios
            </h3>
          </div>
          <div className="space-y-2">
            {directories.map(renderMenuItem)}
          </div>
        </CardBody>
      </Card>

      {/* Area Info */}
      {user?.area && (
        <Card className="border border-gray-200 shadow-post bg-white rounded-nextui">
          <CardBody className="p-4">
            <div className="text-center">
              <Chip color="primary" variant="flat" className="mb-2">
                {user.area.name}
              </Chip>
              <p className="text-xs text-gray-500">
                {user.area.city?.name}, {user.area.city?.state?.name}
              </p>
            </div>
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export default Navigation;
